var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form flex col-2" }, [
    _c("div", { staticClass: "form-group" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.name))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.code))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.bizUnitName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _vm.layoutArea.level == 1 ? _c("span", [_vm._v("一级")]) : _vm._e(),
        _vm._v(" "),
        _vm.layoutArea.level == 2 ? _c("span", [_vm._v("二级")]) : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.desc))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _vm.layoutArea.temperFlag
          ? _c("span", { staticClass: "font-red" }, [_vm._v("是")])
          : _c("span", [_vm._v("否")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s((_vm.layoutArea.temperLow || 0).toFixed(2)))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s((_vm.layoutArea.temperHigh || 0).toFixed(2)))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.temperAffectedDevcTitle))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.temperAffectedDevcTmpNo))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(10),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.creatorName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(11),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.createTime))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(12),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _vm.layoutArea.disabled
          ? _c("span", { staticClass: "font-red" }, [_vm._v("是")])
          : _c("span", [_vm._v("否")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(13),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.disablerName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(14),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.disableCause))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm._m(15),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.layoutArea.disableTime))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("编码：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("等级：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("描述：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("需要控温：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("温度低值(°c)：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("温度高值(°c)：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("设备名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("设备编码：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已禁用：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用人：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用原因：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("禁用时间：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b925eeb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b925eeb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/layoutArea/RetailerLayoutAreaDetail.vue
// module id = 3143
// module chunks = 0